import React, { ImgHTMLAttributes } from 'react';
import LoginImg from './logo/logo.png';
import Bluetech from './logo/bluetech.png';

export function BTLoginImg(props: ImgHTMLAttributes<HTMLImageElement>) {
  const { style, ...rest } = props;
  return (
    <img
      src={LoginImg}
      alt="BlueTech"
      style={{
        maxHeight: '100%',
        maxWidth: '100%',
        height: 'auto',
        width: 'auto',
        objectFit: 'contain',
        display: 'block',
        ...style
      }}
      {...rest}
    />
  );
}

export function BluetechLogo(props: ImgHTMLAttributes<HTMLImageElement>) {
  const { style, ...rest } = props;
  return (
    <img
      src={Bluetech}
      alt="BlueTech"
      style={{
        maxHeight: '100%',
        maxWidth: '100%',
        height: 'auto',
        width: 'auto',
        objectFit: 'contain',
        display: 'block',
        ...style
      }}
      {...rest}
    />
  );
}

export default BTLoginImg;

